import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class ValuedCustomers extends Component {
  
    render() {
        return (
            <div>
                <Banner
                    headText="Valued Customers"
                    subHeadText="Loyalty is a 2-way street"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12 margin5-0">
                                <h4>WE VALUE OUR CUSTOMERS</h4>
                                <p>
                                    We can not overstate how we value each and every client.  Large or small, small enhancements to comprehensive projects, they are 
                                    all equality important to us. With each client we’ve taken the time to thoroughly understand their specific needs and work closely 
                                    with all those involved.  So it is no small statement for us to say we take a tremendous amount of pride in how we have built and 
                                    maintained these special long term business relationships. And while it takes years to build these trusting relationships, if we 
                                    are not always on the top of our game, we know they can all be lost in a minute.<br /><br />

                                    Automated Concepts is not in the business of just landing that big project.  We do not "hit and run" and then move on to the next. 
                                    We always take the time to get to know each and every client to properly understand what will work best for them. Then, and only then, 
                                    will we make any recommendations on the best possible solutions for the challenges or enhancements you are looking for.  
                                    We value them so that they will value us.
                                </p>
                                <br />



                                    <h1 className="bold">What our valued customers are saying...<br />
                                        <span className="techpush">In their own words.</span><br />
                                    </h1><br />
                                    <div className="seprator"></div>
                                    <div id="carousel-example-generic" className="carousel slide" data-ride="carousel">
                                        <div className="carousel-inner">

                                            <div className="item active">
                                                <div className="row padding20" >
                                                    <p className="testimonial_para">
                                                        "After trying off-the-shelf products to no avail, it became obvious that we needed a custom application to solve our data management issues. And we had to make sure the new app played well with the Internet and our other web applications. CustomApps was able to quickly decipher our needs and build us a system that worked perfectly now AND anticipated our future growth without requiring a complete “start-from-scratch” mentality. These Custom Applications now help to control &amp; maintain the majority of our business transactions and we are poised to handle any future change-of-direction that the business community can throw our way."<br /><br />

                                                        <em>Rob Edwards, Vice President, The Job Shop Company, Inc.</em>

                                                        {/* <img src={test1} className="img-circle" alt="" /><br /> */}
                                                    </p>
                                                </div>
                                            </div>


                                            <div className="item ">
                                                <div className="row padding20">
                                                    <p className="testimonial_para">
                                                        "Over twenty-five years ago, our firm hired Automated Concepts to do some programming for a specific project. Impressed by their eagerness to learn everything about what we do and how we do it, we found ourselves turning to them more and more. As our business has grown, Dave and his team have grown with us, anticipating our increasing IT needs. Now, from our extensive client management system to our cybersecurity initiative, nearly every aspect of our infrastructure has Automated Concepts fingerprint on it."<br /><br />

                                                        <em>Bill Anastasiades, President, Pension Consultants, Inc.</em>

                                                        {/* <img src={test1} className="img-circle" alt="" /><br /> */}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="item ">
                                                <div className="row padding20">
                                                    <p className="testimonial_para">
                                                        "For over 10 years Automated Concepts has provided us with dependable, innovative, and highly competent IT services. From day-to-day troubleshooting to designing and implementing our new website, we know that we can trust Automated Concepts to manage the IT solutions for our 5 busy offices. Their services have been essential to advancing our office technologies as we have expanded our business."<br /><br />

                                                        <em>Tom Skahan, President, Newberry Insurance Group</em>

                                                        {/* <img src={test1} className="img-circle" alt="" /><br /> */}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="item ">
                                                <div className="row padding20">
                                                    <p className="testimonial_para">
                                                        "I have worked with Automated Concepts for over 10 years. Prior to meeting its principle Dave Landino, I went through three other firms over a 4-year period. Dave has a keen ear for listening to the client. He ensures he has a complete grasp of their coding expectations. As a rule, Dave always comes back with far better work than I had envisioned. In many instances, he has simplified processes that actually cut himself out of future opportunities. His expertise and honesty give me total piece of mind. My entire business is virtual. I have relied on Dave for years and without question will continue to do so. I highly recommend his services.
                                                    <br /><br />
                                                        I like Dave so much, I sent him flowers last time he was sick!!!"<br /><br />

                                                        <em>John Frey, Founder, National Coalition Of Healthcare Recruiters</em>

                                                        {/* <img src={test1} className="img-circle" alt="" /><br /> */}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="item ">
                                                <div className="row padding20" >
                                                    <p className="testimonial_para">
                                                        "We have been working with Automated Concepts for 3 years. If someone wants to avoid a “cookie cutter process”, I would recommend Automated Concepts. Further, ethics have been demonstrated at every turn. I personally would have no qualms working together on future projects."<br /><br />

                                                        <em>Lucas Karabin, Co-President, Acme Monaco Corporation</em><br /><br />

                                                        "Automated Concepts has become an extension of our IT, Sales and Marketing Team. Dave Landino’s patience and diligence have been extremely beneficial to Acme Monaco’s
                                                     business development. AC not only designed our website but has also provided applications such as Career manager, Customer document portal and On-line catalog to enhance the effectiveness of our customer’s  web experience."<br /><br />

                                                        <em>Jerry Blais, IT Systems Administrator, Acme Monaco Corporation</em>


                                                        {/* <img src={test1} className="img-circle" alt="" /><br /> */}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="controls testimonial_control pull-right">
                                        <a className="left fa fa-chevron-left btn btn-default testimonial_btn" href="#carousel-example-generic"
                                            data-slide="prev"></a>
                                        &nbsp;&nbsp;&nbsp;
                                    <a className="right fa fa-chevron-right btn btn-default testimonial_btn" href="#carousel-example-generic"
                                            data-slide="next"></a>
                                    </div>

                            </div>

                            <InsideContact />

                        </div>
                        <div className="row">


                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(ValuedCustomers);


// WEBPACK FOOTER //
// ./src/components/ValuedCustomers.js